import { render, staticRenderFns } from "./ModalLiberarRepasseUnico.vue?vue&type=template&id=1091372f"
import script from "./ModalLiberarRepasseUnico.vue?vue&type=script&lang=ts"
export * from "./ModalLiberarRepasseUnico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports